	<h2>Product Details</h2>

<div *ngIf="product">
	<h3>{{ product.name }}</h3>

	<div class="pim" *ngFor="let img of product.images">

		<img (click)="showImage(img)" src="{{ img }}" [attr.data-zoom]="img" class="pimi"/>
		
	</div>

	<h4>{{ product.price | currency:'GBP' }}</h4>
  
  <p>{{ product.description }}</p>

  <button (click)="addToBasket(product)">Buy</button>
  <button *ngIf="showCheckout" [routerLink]="['/basket']">Checkout</button>
</div>
